<template>
    <div class="home-pic-root" :style="homePicStyle">
        <img class="home-pic-image" :src="image">
    </div>
</template>

<script>
    export default {
        name: "home-pic",
        props: {
          image: {
              type: String,
              required: true,
          },
          fillColor: {
              type: String,
              required: false,
              default: "#FFF"
          }
        },
        data() {
            return {
                data: {}
            }
        },
        computed: {
            homePicStyle: function () {
                let that = this;
                return {
                    "backgroundColor": that.fillColor
                }
            }
        }

    }
</script>
<style scoped>
    .home-pic-root{
        position: relative;
        width: 100%;
        height: 640px;
        /*background-color: blue;*/
        display: flex;
        flex-direction:row;
        justify-content: space-around;
        align-content: center;
        align-items: center;
    }
    .home-pic-image{
        position: relative;
        width: auto;
        height: 100%;
    }
</style>